import ReactModal from 'react-modal';

import { DEFAULT_MODAL_Z_INDEX } from '@/core/constants/zIndex';

import { ModalStyle, ModalWrapper, StyledOverlay } from './Modal.styles';
import { ModalProps } from './Modal.types';

export const Modal = ({
  children,
  fullWidth,
  isOpen,
  overlayStyle,
  overlayPosition,
  onClose,
  height,
  zIndex = DEFAULT_MODAL_Z_INDEX,
  matchContentSize = false,
  positionX = 'center',
  positionY = 'center',
  clickThroughOverlay = false,
  ...rest
}: ModalProps) => {
  return (
    <ReactModal
      ariaHideApp={false}
      className="modal"
      closeTimeoutMS={350}
      isOpen={isOpen}
      onRequestClose={onClose}
      overlayClassName="modal-overlay"
      contentElement={(props, content) => (
        <ModalWrapper
          positionY={positionY}
          positionX={positionX}
        >
          <ModalStyle
            fullWidth={fullWidth}
            height={height}
            clickThroughOverlay={clickThroughOverlay}
            {...props}
          >
            {content}
          </ModalStyle>
        </ModalWrapper>
      )}
      overlayElement={(props, contentElement) => (
        <StyledOverlay
          {...props}
          overlayStyle={overlayStyle}
          matchContentSize={matchContentSize}
          overlayPosition={overlayPosition}
          zIndex={zIndex}
          clickThroughOverlay={clickThroughOverlay}
        >
          {contentElement}
        </StyledOverlay>
      )}
      {...rest}
    >
      {children}
    </ReactModal>
  );
};
